export default __webpack_public_path__ + "static/usc-697e80114c11dc00c538ba13d1d364a1.svg";